import { useEffect } from "react";
import { useUI } from "../stores/ui";

/**
 * Applies the active theme to <html> via the `.theme-dark` class.
 *
 * uiv2 decisión 1 (2026-05-25): paleta única terracota.
 * No expone selector de acento; sólo toggle light/dark.
 */
export function useThemeApply(): void {
  const theme = useUI((s) => s.theme);
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("theme-dark", theme === "dark");
  }, [theme]);
}
